module.exports = __webpack_public_path__ + "static/img/GPTLOGO.88dcd92a.png";